import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';
import { UnistylesRuntime } from 'react-native-unistyles';

export const DesktopMacbook = (props: SvgProps) => {
  const screenFill =
    UnistylesRuntime.themeName === 'dark' ? '#1E1E22' : '#F5F4F9';

  const xml = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="4.7" width="13" height="9.5" rx="1.2" />
    <rect x="2.3" y="5.9" width="10.4" height="7.1" rx="0.5" fill="${screenFill}" />
    <rect x="5" y="14.2" width="4" height="1.3" />
    <rect x="10.2" y="9.5" width="12" height="8.4" rx="1" />
    <rect x="11.4" y="10.7" width="9.6" height="6" rx="0.4" fill="${screenFill}" />
    <rect x="9.6" y="17.9" width="12.9" height="1.4" />
    </svg>
  `;

  return <SvgXml xml={xml} width="100%" height="100%" {...props} />;
};
